import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["listSelector", "addListButton"];

    connect() {
        // this.handleListSelectorChange(); // Call the function when the controller is connected
    }

    handleListSelectorChange() {
        const selectedListId = this.listSelectorTarget.value;
        this.addListButtonTarget.disabled = selectedListId === "";

        if (this.addListButtonTarget.disabled) {
            this.addListButtonTarget.classList.replace('btn', 'hidden');
        } else {
            this.addListButtonTarget.classList.replace('hidden', 'btn');
            const href = this.addListButtonTarget.href;
            const updatedHref = this.incrementListIndex(href, 1);
            this.updateListIdParam(updatedHref, selectedListId);
        }
    }

    incrementListIndex(href, incrementBy) {
        const url = new URL(href);
        const params = new URLSearchParams(url.search);
        const childIndex = parseInt(params.get("list_index")) + incrementBy;
        params.set("list_index", childIndex.toString());
        url.search = params.toString();
        return url.toString();
    }

    updateListIdParam(href, listId) {
        const url = new URL(href);
        const params = new URLSearchParams(url.search);
        params.set("list_id", listId);
        url.search = params.toString();
        this.addListButtonTarget.href = url.toString();
    }
}
